var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_6409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53556 20.5793C5.40163 20.5793 5.26769 20.5536 5.13926 20.5004C4.75213 20.3399 4.49985 19.9619 4.49985 19.5427V15.953C4.49985 15.3806 4.96404 14.9173 5.53648 14.9173C6.10892 14.9173 6.57311 15.3815 6.57311 15.9539V17.0419L9.47569 14.1394C9.88025 13.7348 10.5362 13.7348 10.9417 14.1394C11.3462 14.5439 11.3462 15.1998 10.9417 15.6053L6.26946 20.2775C6.07131 20.4757 5.80619 20.5812 5.53648 20.5812L5.53556 20.5793Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4632 19.2222C18.1981 19.2222 17.933 19.1212 17.7302 18.9185L11.9774 13.1656C11.7829 12.9712 11.6737 12.7079 11.6737 12.4327C11.6737 12.1574 11.7829 11.8942 11.9774 11.6997L15.1799 8.49712C15.6496 8.02742 15.7781 7.38067 15.5239 6.76695C15.2698 6.15323 14.7212 5.78719 14.0571 5.78719H6.5722V12.6391C6.5722 13.2115 6.10801 13.6757 5.53556 13.6757C4.96312 13.6757 4.49985 13.2115 4.49985 12.6391V4.75148C4.49985 4.17904 4.96404 3.71484 5.53648 3.71484H14.058C15.5661 3.71484 16.8624 4.58085 17.4394 5.97434C18.0165 7.36783 17.7128 8.8971 16.6459 9.96309L14.1754 12.4336L19.1953 17.4535C19.5998 17.858 19.5998 18.5139 19.1953 18.9194C18.9925 19.1222 18.7274 19.2231 18.4623 19.2231L18.4632 19.2222Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_6409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16.8641,
    fill: "white",
    transform: "translate(4.49985 3.71484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemediaIcon);
export default __webpack_public_path__ + "static/media/remedia-icon.208dd506e8b04afb227f122914318b0d.svg";
export { ForwardRef as ReactComponent };